<template lang="html">
  <!-- Desktop utility links (lg+) -->
  <div
    class="app-header-utility hidden border-b border-default lg:block"
    :inert="isCompact ? true : undefined"
    :aria-hidden="isCompact"
  >
    <div class="min-h-0 overflow-hidden">
      <nav
        class="mx-auto flex max-w-(--ui-container) items-center gap-4 px-4 py-2 text-sm text-muted sm:px-6"
        aria-label="Информация о магазине"
      >
        <NuxtLink
          v-for="link in links"
          :key="link.label"
          :to="link.to"
          class="transition-colors hover:text-highlighted focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none motion-reduce:transition-none"
        >
          {{ link.label }}
        </NuxtLink>
      </nav>
    </div>
  </div>

  <!-- Mobile utility: brand logo = hard <a href="/"> (R17 / S50); left-aligned like Photo 8 -->
  <div
    class="app-header-utility-mobile border-b border-default lg:hidden"
    :inert="isCompact ? true : undefined"
    :aria-hidden="isCompact"
  >
    <div class="min-h-0 overflow-hidden">
      <div
        class="flex items-center justify-start px-3 py-2 sm:px-4"
      >
        <a href="/" aria-label="На главную">
          <UIcon :name="brandIcons.logoLargeDark" class="h-9 w-auto sm:h-10" />
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { brandIcons } from '~/app/theme/brand'

export interface AppHeaderUtilityLink {
  label: string
  to: string
}

withDefaults(
  defineProps<{
    isCompact?: boolean
    links?: AppHeaderUtilityLink[]
  }>(),
  {
    isCompact: false,
    /** v1 mapping (R14): Delivery→/faq, About→/about, Contacts→/about */
    links: () => [
      { label: 'Доставка', to: '/faq' },
      { label: 'О бренде', to: '/about' },
      { label: 'Контакты', to: '/about' },
    ],
  },
)
</script>
